import React from 'react';
import styles from './TopBar6.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar6 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.mainContainer}>
        
        {/* Left Section: Socials */}
        <div className={styles.socialSide}>
          <div className={styles.socialContent}>
            <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.socialIcon}>
              <FaFacebookF />
            </a>

            <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.socialIcon}>
              <FaInstagram />
            </a>

            <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.socialIcon}>
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Right Section: Contact */}
        <div className={styles.contactSide}>
          <div className={styles.contactContent}>
            
            <div className={styles.infoLink}>
              <FaPhoneAlt className={styles.miniIcon} />
              <span className={styles.infoText}>{phone}</span>
            </div>

            <div className={styles.verticalLine}></div>

            <div className={styles.infoLink}>
              <FaEnvelope className={styles.miniIcon} />
              <span className={styles.infoText}>{email}</span>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar6;